<template>
    <v-dialog v-model="dialog" width="500" scrollable>
        <template v-slot:activator="{props}">
            <div class="text-caption">
                <span class="me-1">
                    {{ $t(label) }}
                </span>
                <v-chip
                    variant="flat"
                    :color="getColor(1 - ratingObject.rating / 10)"
                    label
                    size="x-small"
                    class="me-1"
                >
                    <span class="text-caption text-white">
                        {{ ratingObject.rating }}
                    </span>
                </v-chip>
                <span class="text-decoration-underline cursor-pointer" v-bind="props" @click="loadReviews">
                    {{ $t('based_on') }} {{ $t('review', ratingObject.reviewsCount) }}
                </span>
            </div>
        </template>
        <v-card>
            <v-card-title>
                <div class="d-flex justify-space-between align-start full-width" style="word-break: break-word">
                    <div>
                        {{ $t('reviews_and_feedback') }}
                    </div>
                    <v-icon class="me-n1 ms-1 mt-1" @click="dialog = false">mdi-close</v-icon>
                </div>
            </v-card-title>
            <v-card-text>
                <div v-if="isFeedbacksLoading" class="d-flex full-width align-center justify-center pa-8">
                    <v-progress-circular color="primary" indeterminate size="64" />
                </div>
                <div v-else class="d-flex flex-column">
                    <div v-for="(feedback, i) in feedbacks" :key="feedback.id" class="d-flex flex-column my-4">
                        <span class="font-weight-bold text--secondary">
                            {{ feedback.clientName }}
                        </span>
                        <span class="text--secondary text-caption">
                            {{ $filters.dateFormat(feedback.created) }}
                        </span>
                        <span v-if="feedback.reviewScore" class="mt-1 d-flex align-center">
                            <v-chip
                                :color="getColor(1 - feedback.reviewScore / 10)"
                                label
                                style="padding-top: 2px"
                                variant="flat"
                                size="x-small"
                                class="me-2 width-max-content"
                            >
                                <div
                                    class="text-caption text-white"
                                    :style="{'border-bottom': feedback.reviewScore === 10 ? '2px solid gold' : null}"
                                >
                                    {{ feedback.reviewScore }}
                                </div>
                            </v-chip>
                            <span class="text-black font-weight-medium" style="margin-top: 2px">
                                {{ $t(`ratingByClientsFeedback.${getRatingLabel(feedback.reviewScore)}`) }}
                            </span>
                        </span>
                        <div class="d-flex flex-column py-4 text-black">
                            <span v-if="feedback.positiveFeedback">
                                <span class="text-success me-1 font-weight-bold">+</span>
                                <span>
                                    {{ feedback.positiveFeedback }}
                                </span>
                            </span>
                            <span v-if="feedback.negativeFeedback">
                                <span
                                    class="text-error me-1 font-weight-bold"
                                    style="padding-left: 1px; padding-right: 1px"
                                    >-</span
                                >
                                <span>
                                    {{ feedback.negativeFeedback }}
                                </span>
                            </span>
                        </div>
                        <v-divider v-if="i !== feedbacks.length - 1" />
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import {ratingByClientsFeedbackAdapter} from '@/utils/hotels/hotel-transformers'

    @Component
    export default class RatingClientsFeedback extends Vue {
        @Prop({default: () => 'review_score'}) label
        @Prop({required: true}) ratingObject
        @Prop({required: true}) productCode
        @Prop({required: true}) cityCode
        @Prop({required: true}) supplierCode

        dialog = false

        isFeedbacksLoading = false
        feedbacks = []

        async loadReviews() {
            try {
                this.feedbacks = []
                this.isFeedbacksLoading = true

                this.feedbacks = (
                    await this.$api.reviews.get({
                        ...(this.productCode && {productCode: this.productCode}),
                        ...(this.cityCode && {cityCode: this.cityCode}),
                        ...(this.supplierCode && {supplierCode: this.supplierCode}),
                        status: 'PUBLISHED',
                    })
                ).reviews
            } catch (e) {
                this.dialog = false
            } finally {
                this.isFeedbacksLoading = false
            }
        }

        getColor(value) {
            const hue = ((1 - value) * 120).toString(10)
            return ['hsl(', hue, ',100%, 30%)'].join('')
        }

        getRatingLabel(rating) {
            if (rating === 10) {
                return 'excellent'
            }
            return ratingByClientsFeedbackAdapter(rating)
        }
    }
</script>
